var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L10.5863 4.44033L15.6085 5.52786L12.1846 9.35967L12.7023 14.4721L8 12.4L3.29772 14.4721L3.81535 9.35967L0.391548 5.52786L5.41374 4.44033L8 0Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/Star 2.5011c6b3f322fede31947adcb4d2d41d.svg";
export { ForwardRef as ReactComponent };